/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
import { CloseXIcon, DebugIcon, ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from '../../icons';
import styles from './MessageBanner.module.scss';

const icons = {
  debug: DebugIcon,
  error: ErrorIcon,
  info: InfoIcon,
  success: SuccessIcon,
  warning: WarningIcon,
};
const ICON_SIZE = 20;
const CLOSE_SIZE = 18;

function MessageBanner({
  children,
  isClosable = true,
  messageType = 'info',
  onClose = () => {},
}) {
  const Icon = icons[messageType] ?? InfoIcon;
  return (
    <div className={`${styles.message} ${styles[messageType]}`}>
      <div className={`${styles.icon}`} style={{ height: `${ICON_SIZE}px` }}>
        <Icon size={ICON_SIZE} />
      </div>
      {children}
      {isClosable && (
        <button aria-label="Close message" style={{ display: 'block' }} type="button" onClick={onClose}>
          <div className={`${styles.close}`} style={{ width: `${CLOSE_SIZE}px` }}>
            <CloseXIcon size={CLOSE_SIZE} />
          </div>
        </button>
      )}
    </div>
  );
}

MessageBanner.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string,
    ])),
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
  isClosable: PropTypes.bool,
  messageType: PropTypes.oneOf(['success', 'error', 'warning', 'info', 'debug']),
  onClose: PropTypes.func,
};

export default MessageBanner;
